import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ExercicioForm from "../../../components/forms/ExercicioForm.vue";
import { ExercicioService } from "../../../services/ExercicioService";

export default {
    name: "EditarExercicio",
    components: {
        Breadcrumb,
        ExercicioForm
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Exercícios',
                disabled: false,
                href: '/gerenciar-exercicios',
            },
            {
                text: 'Editar Exercício',
                disabled: true
            }
        ],
        exercicioData: {}
    }),
    created() {
        this.carregarExercicio();
    },
    methods: {
        async carregarExercicio() {
            try {
                const response = await ExercicioService.show(this.$route.params.id);

                if (response && response.data) {
                    const data = response.data;
                    // Garantir que o ano tenha 4 dígitos
                    const ano = data.ano.toString().padStart(4, '0');
                    this.exercicioData = {
                        exercicio: ano,
                        ativo: Boolean(data.ativo)
                    };
                } else {
                    console.error('Não foi possível carregar os dados do Exercício.');
                    this.$globalAlert('Erro ao carregar dados do Exercício');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados do Exercício:', error);
                this.$globalAlert('Erro ao carregar dados do Exercício');
            }
        },
        async handleSave(formData) {
            try {
                const dataToSend = new FormData();
                dataToSend.append("ano", formData.exercicio);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await ExercicioService.update(this.$route.params.id, dataToSend);

                if (response) {
                    this.$router.push('/gerenciar-exercicios');
                } else {
                    this.$globalAlert('Erro ao atualizar Exercício');
                }
            } catch (error) {
                console.error('Erro ao salvar:', error);
                this.$globalAlert('Erro ao atualizar Exercício');
            }
        },
        handleCancel() {
            this.$router.push('/gerenciar-exercicios');
        }
    }
};
